import {PageAside} from 'core/layouts/layout2/core';
import {Menu} from 'app/layout/_core/Menu';
import SellerListPage from './SellerListPage';
const CustomerPage = () => {
  return (
    <div>
      <PageAside>
        <Menu />
      </PageAside>
      <SellerListPage/>
    </div>
  );
};

export default CustomerPage;
